
if (!customElements.get("collection-tabs")) {
  class CollectionTabs extends HTMLElement {
    constructor() {
      super();
      this.panelCache = new Map();
      this.activeTabId = null;
    }

    connectedCallback() {
      this.nav = this.querySelector('.collection-tabs__nav');
      this.content = this.querySelector('.collection-tabs__content');
      this.navButtons = [...this.querySelectorAll('.collection-tabs__nav button')];
      this.indicator = this.querySelector('.collection-tabs__indicator');

      const panels = [...this.querySelectorAll('.collection-tabs__panel')];

      if (!this.navButtons.length || !panels.length) return;

      // ✅ Cache panels & remove from DOM
      panels.forEach(panel => {
        this.panelCache.set(panel.id, panel);
        panel.remove();
      });

      this.navButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          this.switchTab(btn.dataset.tab);
        });
      });

      // Init first tab
      const firstTab = this.navButtons[0]?.dataset.tab;
      if (firstTab) this.switchTab(firstTab, true);
    }

    switchTab(tabId, initial = false) {
      if (this.activeTabId === tabId) return;

      const activeButton = this.querySelector(`[data-tab="${tabId}"]`);
      const panel = this.panelCache.get(tabId);

      if (!activeButton || !panel) return;

      // Remove old panel
      if (this.activeTabId) {
        const oldPanel = this.panelCache.get(this.activeTabId);
        oldPanel?.remove();
      }

      // Activate button
      this.navButtons.forEach(btn => btn.classList.remove('active'));
      activeButton.classList.add('active');

      // Add new panel
      this.content.appendChild(panel);
      panel.classList.add('active');

      this.activeTabId = tabId;

      // ✅ Update View All link
      const viewAllUrl = activeButton.dataset.viewallurl;
      this.querySelectorAll('.custom-event-view-all').forEach(link => {
        if (viewAllUrl) link.href = viewAllUrl;
      });

      // ✅ Indicator movement
      const buttonRect = activeButton.getBoundingClientRect();
      const navRect = this.nav.getBoundingClientRect();

      this.indicator.style.width = `${buttonRect.width}px`;
      this.indicator.style.transform = `translateX(${buttonRect.left - navRect.left}px)`;

      // ✅ Refresh carousel
      requestAnimationFrame(() => {
        const carousel = panel.querySelector('carousel-component');
        if (carousel?.refreshSlider) {
          try {
            carousel.refreshSlider();
          } catch (e) {
            console.warn('Carousel refresh failed', e);
          }
        }
      });
    }
  }

  customElements.define('collection-tabs', CollectionTabs);
}
